import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { FirestoreService } from 'src/app/services/service.index';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-itemedit',
  templateUrl: './itemedit.component.html',
  styleUrls: ['./itemedit.component.css']
})
export class ItemeditComponent implements OnInit {

  user:any;

  companyId:any;

  urlImg:any = "../../../assets/img/images.jpeg";

  drivers = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  //'id',
  displayedColumns: string[] = [ 'select', 'plate', 'model', 'mark', 'year', 'driver', 'status', 'actions'];


  driversList: any = [];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  selection = new SelectionModel<any>(true, []);

  forma = new FormGroup({
    id: new FormControl(),
    code: new FormControl( { value: null, disabled: true }, Validators.required),
    name: new FormControl(),
    description: new FormControl(),
    status: new FormControl(false),
  });

  dataSelected:any;

  carsList: any = [];

  constructor(private afs: FirestoreService,
              public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: any) {


      this.dataSelected = data;

  }

  ngOnInit(): void {

      this.user = this.afs.usersShow;




      this.afs.getItem(this.user.companyId, this.dataSelected.id).subscribe( res => {


        this.initValueForm(res);

      });

  }

  initValueForm(car: any){

    // this.urlImg = user.img || this.urlImg;
    // this.id = user.id;

     this.forma.patchValue({
      id: car.id,
      code: car.code,
      name: car.name,
      description: car.description,
      status: car.status
     });

   }

   editItem(){


     if (this.forma.invalid) {

         Swal.fire('Oops...', 'Form is invalid!!', 'error');

      }



      this.afs.updateItem(this.user.companyId, this.forma.value.id, this.forma.value).then((resp) => {

        //this.afs.saveStorage(this.forma.value.id, this.forma.value);

        Swal.fire('Good job!', 'Item ha been updated!', 'success');


        this.dialogRef.close();


      }).catch((err) =>{


        Swal.fire('Oops...', 'Item has not been updated!!', 'error');

     })


   }


}
